module.exports = __webpack_public_path__ + "img/2_134.b1fe6735.png";